<div class="layout-row gap-md">
  @if (workOrder$ | async; as workOrder) {
    <mat-form-field [floatLabel]="'always'" style="width: 100px">
      <mat-label>{{ 'context.production' | translate }}</mat-label>
      <input
        matInput
        type="text"
        name="facility"
        [value]="workOrder.manufactureFacility"
        readonly
        placeholder="{{ 'context.production' | translate }}"
      />
      <mat-error elderValidationError></mat-error>
    </mat-form-field>
    <mat-form-field [floatLabel]="'always'" style="width: 100px">
      <mat-label>{{ 'context.collection' | translate }}</mat-label>
      <input
        matInput
        type="text"
        name="collectingFacility"
        [value]="workOrder.collectingFacility"
        readonly
        placeholder="{{ 'context.collection' | translate }}"
      />
      <mat-error elderValidationError></mat-error>
    </mat-form-field>
  }

  @if (overview$ | async; as overview) {
    <mat-form-field floatLabel="always" style="width: 100px">
      <mat-label>{{ 'context.items' | translate }}</mat-label>
      <elder-quantity-input
        name="numberOfItems"
        readonly
        placeholder="{{ 'context.items' | translate }}"
        [quantityValue]="overview.aggregate.total?.numberOfItems"
        [unit]="Unit.pc"
      >
      </elder-quantity-input>
      <mat-error elderValidationError></mat-error>
    </mat-form-field>
    <mat-form-field floatLabel="always" style="width: 100px">
      <mat-label>{{ 'context.weight' | translate }}</mat-label>
      <elder-quantity-input
        name="weight"
        readonly
        placeholder="{{ 'context.weight' | translate }}"
        [ngModel]="overview.aggregate.total?.weight"
      >
      </elder-quantity-input>
      <mat-error elderValidationError></mat-error>
    </mat-form-field>
  }
</div>
